import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

export interface Preferences{
    id                : number,
    user_id           : number,
    client_timezone   : string,
    client_tz_abbr    : string,
    agent_timezone    : string,
    agent_tz_abbr     : string,
    appt_duration     : string,
    dk_duration       : string,
    cb_duration       : string,
    dial_type         : string,
    cellphone         : number,
    homephone         : number,
    workphone         : number,
    client_notify     : string,
    before_hour       : number,
    agent_notify      : string,
    didpicktype       : string,
    manual_did        : string,
    autodialing_delay : number,
    appt_from_time    : string,
    appt_to_time      : string,
    minimum_distance  : number,
    music_on_hold     : string,
    ringing_time      : number,
    call_recording    : string,
    sorting_leads     : string,
    id_campaign :string,
    smsreminder:number
}

export interface HTTPPreferences
{
    user_id            : number,
    client_timezone    : string,
    client_tz_abbr     : string,
    agent_timezone     : string,
    agent_tz_abbr      : string,
    appt_duration      : string,
    dk_duration        : string,
    cb_duration        : string,
    dial_type          : string,
    cellphone          : number,
    homephone          : number,
    workphone          : number,
    client_notify      : string,
    before_hour        : number,
    agent_notify       : string,
    didpicktype        : string,
    manual_did         : string,
    autodialing_delay  : number,
    appt_from_time     : string,
    appt_to_time       : string,
    minimum_distance   : number,
    music_on_hold      : string,
    ringing_time       : number,
    call_recording     : string,
    sorting_leads      : string,
    id_campaign : string,
    smsreminder: number
}

export class PreferencesForm implements HTTPPreferences{
    public user_id          : number;
    public client_timezone  : string;
    public client_tz_abbr   : string;
    public agent_timezone   : string;
    public agent_tz_abbr    : string;
    public appt_duration    : string;
    public dk_duration      : string;
    public cb_duration      : string;
    public dial_type        : string;
    public cellphone        : number;
    public homephone        : number;
    public workphone        : number;
    public client_notify    : string;
    public before_hour      : number;
    public agent_notify     : string;
    public didpicktype      : string;
    public manual_did       : string;
    public autodialing_delay : number;
    public appt_from_time   : string;
    public appt_to_time     : string;
    public minimum_distance : number;
    public music_on_hold    : string;
    public ringing_time     : number;
    public call_recording   : string;
    public sorting_leads    : string;
    public id_campaign : string;
    public smsreminder : number;

    constructor(data : Preferences)
    {
        if(data==null)
        {
            this.user_id           = parseInt(sessionStorage.getItem('userid'));;
            this.client_timezone   = "";
            this.client_tz_abbr    = "";
            this.agent_timezone    = "";
            this.agent_tz_abbr     = "";
            this.appt_duration     = "1:00";
            this.dk_duration       = "0:30";
            this.cb_duration       = "0:15";
            this.dial_type         = "automatic";
            this.cellphone         = 3;
            this.homephone         = 2;
            this.workphone         = 1;
            this.client_notify     = "both";
            this.before_hour       = 2;
            this.agent_notify      = "agent";
            this.didpicktype       = "automatic";
            this.manual_did        = "";
            this.autodialing_delay = 1;
            this.appt_from_time    = "";
            this.appt_to_time      = "";
            this.minimum_distance  = 30;
            this.music_on_hold     = "";
            this.ringing_time      = 15;
            this.call_recording    = "off";
            this.sorting_leads     = "";
            this.id_campaign       = "0";
            this.smsreminder       = 1;
        }
        else
        {
            this.user_id            = parseInt(sessionStorage.getItem('userid'));;
            this.client_timezone    = data.client_timezone;
            this.client_tz_abbr     = data.client_tz_abbr;
            this.agent_timezone     = data.agent_timezone;
            this.agent_tz_abbr      = data.agent_tz_abbr;
            this.appt_duration      = data.appt_duration;
            this.dk_duration        = data.dk_duration;
            this.cb_duration        = data.cb_duration;
            this.dial_type          = data.dial_type;
            this.cellphone          = data.cellphone;
            this.homephone          = data.homephone;
            this.workphone          = data.workphone;
            this.client_notify      = data.client_notify;
            this.before_hour        = data.before_hour;
            this.agent_notify       = data.agent_notify;
            this.didpicktype        = data.didpicktype;
            this.manual_did         = data.manual_did;
            this.autodialing_delay  = data.autodialing_delay;
            this.appt_from_time     = data.appt_from_time;
            this.appt_to_time       = data.appt_to_time;
            this.minimum_distance   = data.minimum_distance;
            this.music_on_hold      = data.music_on_hold;
            this.ringing_time       = data.ringing_time;
            this.call_recording     = data.call_recording;
            this.sorting_leads      = data.sorting_leads;
            this.id_campaign        = data.id_campaign;
            this.smsreminder        = data.smsreminder;
        }
    }

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            client_timezone        : [this.client_timezone],
            client_tz_abbr         : [this.client_tz_abbr],
            agent_timezone         : [this.agent_timezone],
            agent_tz_abbr          : [this.agent_tz_abbr],
            appt_duration          : [this.appt_duration],
            dk_duration            : [this.dk_duration],
            cb_duration            : [this.cb_duration],
            dial_type              : [this.dial_type],
            cellphone              : [this.cellphone, [Validators.required, Validators.max(9),Validators.min(0)]],
            homephone              : [this.homephone, [Validators.required, Validators.max(9),Validators.min(0)]],
            workphone              : [this.workphone, [Validators.required, Validators.max(9),Validators.min(0)]],
            client_notify          : [this.client_notify],
            before_hour            : [this.before_hour],//, [Validators.required, Validators.max(12),Validators.min(1)]],
            agent_notify           : [this.agent_notify],
            didpicktype            : [this.didpicktype],
            manual_did             : [this.manual_did],
            autodialing_delay      : [this.autodialing_delay, [Validators.required, Validators.max(100),Validators.min(1)]],
            appt_from_time         : [this.appt_from_time],
            appt_to_time           : [this.appt_to_time],
           // minimum_distance       : [this.minimum_distance,[Validators.required, Validators.max(500),Validators.min(5)]],
            minimum_distance       : [this.minimum_distance],
            music_on_hold          : [this.music_on_hold],
            ringing_time           : [this.ringing_time, [Validators.required, Validators.max(20),Validators.min(10)]],
            call_recording         : [this.call_recording],
            sorting_leads          : [this.sorting_leads],
            id_campaign            : [this.id_campaign],
            smsreminder            : [this.smsreminder]
        });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
            this.client_timezone      = fg.get("client_timezone").value;
            this.client_tz_abbr       = fg.get("client_tz_abbr").value;
            this.agent_timezone       = fg.get("agent_timezone").value;
            this.agent_tz_abbr        = fg.get("agent_tz_abbr").value;
            this.appt_duration        = fg.get("appt_duration").value;
            this.dk_duration          = fg.get("dk_duration").value;
            this.cb_duration          = fg.get("cb_duration").value;
            this.dial_type            = fg.get("dial_type").value;
            this.cellphone            = fg.get("cellphone").value;
            this.homephone            = fg.get("homephone").value;
            this.workphone            = fg.get("workphone").value;
            this.client_notify        = fg.get("client_notify").value;
            this.before_hour          = fg.get("before_hour").value;
            this.agent_notify         = fg.get("agent_notify").value;
            this.didpicktype          = fg.get("didpicktype").value;
            this.manual_did           = fg.get("manual_did").value;
            this.autodialing_delay    = fg.get("autodialing_delay").value;
            this.appt_from_time       = fg.get("appt_from_time").value;
            this.appt_to_time         = fg.get("appt_to_time").value;
            this.minimum_distance     = fg.get("minimum_distance").value;
            this.music_on_hold        = fg.get("music_on_hold").value;
            this.ringing_time         = fg.get("ringing_time").value;
            this.call_recording       = fg.get("call_recording").value;
            this.sorting_leads        = fg.get("sorting_leads").value;
            this.id_campaign          = fg.get("id_campaign").value;
            this.smsreminder          = fg.get("smsreminder").value;
            return true;
        }
        else
        {
            return false;
        }
    }
}

// export interface GlobalFilter{
//     id          : number,
//     user_id     : number,
//     state       : string[],
//     county      : string[],
//     city        : string[],
//     zip         : string[],
//     lead_level  : string[],
//     lead_type   : string,
//     assign_date : string,
//     assign_todate : string,
//     age_from    : number,
//     age_to      : number,
//     global_filter : string,
//     countyname  : string,
//     cityname    : string,
//     zipname     : string,
//     upload_from : string,
//     upload_to   : string,
//     id_campaign : string,
//     leadscript :string,
//     message:string,
//     isdefault:number,
//     filtername:string,
//     disposition:string,
//     callqueued:string,
//     dob:string,
//     todob:string
// }

export interface HTTPGlobalFilter
{
    user_id         : number,
    state           : string[],
    county          : string[],
    city            : string[],
    zip             : string[],
    lead_level      : string[],
    lead_type       : string,
    assign_date     : string,
    assign_todate   : string,
    age_from        : number,
    age_to          : number,
    global_filter   : string,
    countyname      : string,
    cityname        : string,
    zipname         : string,
    upload_from     : string,
    upload_to       : string,
    id_campaign : string,
    filtername: string,
    disposition:string,
    callqueued:string,
    dob:string,
    todob:string
}

export class GlobalFilterForm implements HTTPGlobalFilter{
    public user_id       : number;
    public state         : string[];
    public county        : string[];
    public city          : string[];
    public zip           : string[];
    public lead_level    : string[];
    public lead_type     : string;
    public assign_date   : string;
    public assign_todate : string;
    public age_from      : number;
    public age_to        : number;
    public global_filter : string;
    public countyname    : string;
    public cityname      : string;
    public zipname       : string;
    public upload_from   : string;
    public upload_to     : string;
    public id_campaign : string;
    public filtername : string;
    public disposition : string;
    public callqueued:string;
    public dob:string;
    public todob:string;

    // constructor(data : GlobalFilter)
    // {
    //     if(data==null)
    //     {
    //         this.user_id     = parseInt(sessionStorage.getItem('userid'));;
    //         this.state       = [];
    //         this.county      = [];
    //         this.city        = [];
    //         this.zip         = [];
    //         this.lead_level  = [];
    //         this.lead_type   = '';
    //         this.assign_date = "";
    //         this.assign_todate="";
    //         this.age_from    = null;
    //         this.age_to      = null;
    //         this.global_filter="";
    //         this.countyname  = "";
    //         this.cityname    = "";
    //         this.zipname     = "";
    //         this.upload_from = "";
    //         this.upload_to   = "";
    //         this.id_campaign = "0";
    //         this.filtername ="";
    //         this.disposition="";
    //         this.callqueued = '-1';
    //         this.dob="";
    //         this.todob = "";
    //     }
    //     else
    //     {
    //        /*  if(data.assign_date=="" || data.assign_todate=="" || data.upload_from=="" || data.upload_to=="")
    //         {
    //             this.assign_date="";
    //             this.assign_todate="";
    //             this.upload_from="";
    //             this.upload_to="";
    //         }
    //         else{
    //             this.assign_date    = new Date(data.assign_date).toISOString();
    //             this.assign_todate  = new Date(data.assign_todate).toISOString();
    //             this.upload_from    = new Date(data.upload_from).toISOString();
    //             this.upload_to      = new Date(data.upload_to).toISOString();
    //         } */
    //         console.log(this.assign_date);
    //         this.user_id        = parseInt(sessionStorage.getItem('userid'));;
    //         this.state          = data.state;
    //         this.county         = data.county;
    //         this.city           = data.city;
    //         this.zip            = data.zip;
    //         this.lead_level     = data.lead_level;
    //         this.lead_type      = data.lead_type;
    //         this.assign_date    = data.assign_date;
    //         this.assign_todate  = data.assign_todate;
    //         this.upload_from    = data.upload_from;
    //         this.upload_to      = data.upload_to;

    //         this.age_from       = data.age_from;
    //         this.age_to         = data.age_to;
    //         this.global_filter  = data.global_filter;
    //         this.countyname     = data.countyname;
    //         this.cityname       = data.cityname;
    //         this.zipname        = data.zipname;

    //         this.id_campaign = data.id_campaign;
    //         this.filtername = data.filtername;
    //         this.disposition = data.disposition;
    //         this.callqueued = data.callqueued;
    //         this.dob = data.dob;
    //         this.todob = data.todob;
    //     }
    // }

    public makeform(fb:FormBuilder):FormGroup
    {
        console.log(this.countyname);
        console.log(this.cityname);
        return fb.group({
            state               : [this.state],
            county              : [this.county],
            city                : [this.city],
            zip                 : [this.zip],
            lead_level          : [this.lead_level],
            lead_type           : [this.lead_type],
            assign_date         : [this.assign_date],
            assign_todate       : [this.assign_todate],
            age_from            : [this.age_from],
            age_to              : [this.age_to],
            global_filter       : [this.global_filter],
            countyname          : [this.countyname],
            cityname            : [this.cityname],
            zipname             : [this.zipname],
            upload_from         : [this.upload_from],
            upload_to           : [this.upload_to],
            id_campaign : [this.id_campaign],
            filtername : [this.filtername, Validators.required],
            disposition : [this.disposition],
            callqueued : [this.callqueued],
            dob : [this.dob],
            todob : [this.todob]
        });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
            this.state            = fg.get("state").value;
            this.county           = fg.get("county").value;
            this.city             = fg.get("city").value;
            this.zip              = fg.get("zip").value;
            this.lead_level       = fg.get("lead_level").value;
            this.lead_type        = fg.get("lead_type").value;
            this.assign_date      = fg.get("assign_date").value;
            this.assign_todate    = fg.get("assign_todate").value;
            this.age_from         = fg.get("age_from").value;
            this.age_to           = fg.get("age_to").value;
            this.global_filter    = fg.get("global_filter").value;
            this.countyname       = "";
            this.cityname         = "";
            this.zipname          = "";
            this.upload_from      = fg.get("upload_from").value;
            this.upload_to        = fg.get("upload_to").value;
            this.id_campaign = fg.get("id_campaign").value;
            this.filtername = fg.get("filtername").value;
            this.disposition = fg.get("disposition").value;
            this.callqueued = fg.get("callqueued").value;
            this.dob = fg.get("dob").value;
            this.todob = fg.get("todob").value;
            return true;
        }
        else
        {
            return false;
        }
    }
}

export interface Smtp
{    
    id         : number,
    iduser     : number,
    idparent   : number,
    fullname   : string,
    emailid    : string,
    password   : string,
    domain     : string,
    username   : string,
    smtp_port  : number,
    status     : number,
    cc         : string,
    bcc        : string,
    reply      : string,
    reply_name : string,
    default    : number,
    emailtype  : any
}

export interface HTTPSmtp
{
    iduser     : number,
    fullname   : string,
    emailid    : string,
    password   : string,
    domain     : string,
    username   : string,
    smtp_port  : number,
    status     : number,
    emailtype  : number;
    cc         : string;
    bcc        : string;
    reply      : string;
    reply_name : string;
    default    : number;

}

export class SmtpForm implements HTTPSmtp{
    public iduser     : number
    public fullname   : string;
    public emailid    : string;
    public password   : string;
    public domain     : string;
    public smtp_port  : number
    public username   : string;
    public status     : number;
    public emailtype  : number;
    public cc         : string;
    public bcc        : string;
    public reply      : string;
    public reply_name : string;
    public default    : number;

    constructor(data : Smtp)
    {
        if(data==null)
        {
            this.iduser     = parseInt(sessionStorage.getItem('userid'));
            this.fullname   = "";
            this.emailid    = "";
            this.password   = "";
            this.domain     = "";
            this.smtp_port  = null;
            this.username   = "";
            this.status     = 0
            this.emailtype  = 0;
            this.cc         = "";
            this.bcc        = "";
            this.reply      = "";
            this.reply_name = "";
            this.default    = 0;
        }
        else
        {
            this.iduser      = parseInt(sessionStorage.getItem('userid'));
            this.fullname    = data.fullname;
            this.emailid     = data.emailid;
            this.password    = data.password;
            this.domain      = data.domain;
            this.smtp_port   = data.smtp_port;
            this.username    = data.username;
            this.status      = data.status ;
            this.emailtype   = data.emailtype
            this.cc          = data.cc;
            this.bcc         = data.bcc;
            this.reply       = data.reply;
            this.reply_name  = data.reply_name;
            this.default     = data.default;
        }
    }

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
          fullname   : [this.fullname, Validators.required],
          emailid    : [this.emailid, [Validators.required, Validators.email]],
          password   : [this.password, Validators.required],
          domain     : [this.domain, Validators.required],
          smtp_port  : [this.smtp_port, [Validators.required, Validators.minLength(3)]],
          username   : [this.username, Validators.required] ,
          cc         : [this.cc],
          bcc        : [this.bcc],
          reply      : [this.reply],
          reply_name : [this.reply_name],
          emailtype  : [this.emailtype],
          default    : [this.default]
      });
  }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
            this.iduser      = parseInt(sessionStorage.getItem('userid'));
            this.fullname    = fg.get("fullname").value;
            this.emailid     = fg.get("emailid").value;
            this.password    = fg.get("password").value;
            this.domain      = fg.get("domain").value;
            this.smtp_port   = fg.get("smtp_port").value;
            this.username    = fg.get("username").value;
            this.emailtype   = fg.get("emailtype").value;
            this.cc          = fg.get("cc").value;
            this.bcc         = fg.get("bcc").value;
            this.reply       = fg.get("reply").value;
            this.reply_name  = fg.get("reply_name").value;
            this.default     = fg.get("default").value;

          return true;
        }
        else
        {
            return false;
        }
    }
}

export interface Supplier
{
    id         : number,
    name       : string,
    unicode    : string,
    prefix     : string,
    ip         : string,
    sipdomain  : string,
    username   : string,
    password   : string,
    rate       : number,
    isdefault : number,
    issupplier : number
}

export interface HTTPSupplier
{
    name       : string,
    unicode    : string,
    prefix     : string,
    ip         : string,
    sipdomain  : string,
    username   : string,
    password   : string,
    rate       : number
}

export class SupplierForm implements HTTPSupplier{
    public name       : string;
    public unicode    : string;
    public prefix     : string;
    public ip         : string;
    public sipdomain  : string;
    public username   : string;
    public password   : string;
    public rate       : number;

    constructor(data : Supplier)
    {
        if(data==null)
        {
            this.name       = "";
            this.unicode    = "";
            this.prefix     = "";
            this.ip         = "";
            this.sipdomain  = "";
            this.username   = "";
            this.password   = "";
            this.rate       = 0;

        }
        else
        {
            this.name        = data.name;
            this.unicode     = data.unicode;
            this.prefix      = data.prefix;
            this.ip          = data.ip;
            this.sipdomain   = data.sipdomain;
            this.username     = data.username;
            this.password     = data.password;
            this.rate         = data.rate;
        }
}

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
          name         : [this.name,Validators.required],
          unicode      : [this.unicode],
          prefix       : [this.prefix],
          ip           : [this.ip],
          sipdomain    : [this.sipdomain],
          username     : [this.username,Validators.required],
          password     : [this.password,Validators.required],
          rate         : [this.rate]
      });
  }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
            this.name        = fg.get("name").value;
            this.unicode     = fg.get("unicode").value;
            this.prefix      =  fg.get("prefix").value;
            this.ip          =  fg.get("ip").value;
            this.sipdomain   = fg.get("sipdomain").value;
            this.username    = fg.get("username").value;
            this.password    =  fg.get("password").value;
            this.rate        =  fg.get("rate").value;
          return true;
        }
        else
        {
            return false;
        }
    }
}

export interface Central
{
    id                   : number,
    iduser               : number,
    in_rate              : number,
    appt_confirm         : number,
    agent_notify         : number,
    appt_rem          : number,
    dialer_notify       : number,
    id_campaign : string
}

export interface HTTPCentral
{   iduser               : number,
    in_rate              : number,
    appt_confirm            : number,
    agent_notify     : number,
    appt_rem          : number,
    dialer_notify       : number,
    id_campaign :string
}

export class CentralForm implements HTTPCentral{
    public iduser             : number;
    public in_rate            : number;
    public appt_confirm          : number;
    public agent_notify   : number;
    public appt_rem        : number;
    public dialer_notify     : number;
    public id_campaign : string;

    constructor(data : Central)
    {
        if(data==null)
        {
            this.iduser           = parseInt(sessionStorage.getItem('userid'));
            this.in_rate          = 0;
            this.appt_confirm     = 0;
            this.agent_notify     = 0;
            this.appt_rem         = 0;
            this.dialer_notify    = 0;
            this.id_campaign      ='0';
        }
        else
        {
            this.iduser            = parseInt(sessionStorage.getItem('userid'));
            this.in_rate           = data.in_rate;
            this.appt_confirm      = data.appt_confirm;
            this.agent_notify  = data.agent_notify;
            this.appt_rem       = data.appt_rem;
            this.dialer_notify    = data.dialer_notify;
            this.id_campaign = data.id_campaign;
        }
}

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            in_rate              : [this.in_rate],
            appt_confirm            : [this.appt_confirm],
            agent_notify     : [this.agent_notify],
            appt_rem          : [this.appt_rem],
            dialer_notify       : [this.dialer_notify],
            id_campaign : [this.id_campaign]
      });
  }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
            this.iduser = parseInt(sessionStorage.getItem('userid'));
            this.in_rate = fg.get("in_rate").value;
            this.appt_confirm = fg.get("appt_confirm").value;
            this.agent_notify = fg.get("agent_notify").value;
            this.appt_rem = fg.get("appt_rem").value;
            this.dialer_notify = fg.get("dialer_notify").value;
            this.id_campaign = fg.get("id_campaign").value;
          return true;
      }
      else
      {
          return false;
      }
    }
}


// used for Calendar Api

export interface CalendarApi
{
    id                   : number,
    client_id            : string,
    discoveryDocs        : string,
    scope                : string
}

export interface HTTPCalendarApi
{
    client_id               : string,
    discoveryDocs           : string,
    scope                   : string
}

export class CalendarApiForm implements HTTPCalendarApi
{
    public client_id             : string;
    public discoveryDocs         : string;
    public scope                 : string;

    constructor(data : CalendarApi)
    {
        if(data==null)
        {
            this.client_id          = '';
            this.discoveryDocs      = '';
            this.scope              = '';
        }
        else
        {
            this.client_id          = data.client_id;
            this.discoveryDocs      = data.discoveryDocs;
            this.scope              = data.scope;
        }
    }

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            client_id              : [this.client_id],
            discoveryDocs          : [this.discoveryDocs],
            scope                  : [this.scope]
        });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
            this.client_id       = fg.get("client_id").value;
            this.discoveryDocs   = fg.get("discoveryDocs").value;
            this.scope           = fg.get("scope").value;
          return true;
        }
        else
        {
            return false;
        }
    }
}

// add for map api

export interface MapApi
{
    id             : number,
    diskey         : string,
    dismode        : string,
    dislanguage    : string
}

export interface HTTPMapApi
{
    diskey            : string,
    dismode           : string,
    dislanguage       : string
}

export class MapApiForm implements HTTPMapApi
{
    public diskey          : string;
    public dismode         : string;
    public dislanguage      : string;

    constructor(data : MapApi)
    {
        if(data==null)
        {
            this.diskey         = '';
            this.dismode        = '';
            this.dislanguage    = '';
        }
        else
        {
            this.diskey         = data.diskey;
            this.dismode        = data.dismode;
            this.dislanguage    = data.dislanguage;
        }
    }

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            diskey           : [this.diskey],
            dismode          : [this.dismode],
            dislanguage      : [this.dislanguage]
      });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
            this.diskey            = fg.get("diskey").value;
            this.dismode           = fg.get("dismode").value;
            this.dislanguage       = fg.get("dislanguage").value;
          return true;
        }
        else
        {
            return false;
        }
    }
}

/* Company Setting Access */

export interface CompanyAccess
{
    id            : number,
    iduser        : number,
    isdidapi      : number,
    issupplier    : number,
    isstripe      : number,
    issmtp        : number,
    iscalendar    : number,
    ismapapi      : number
}

export interface HTTPCompanyAccess {}

export class CompanyAccessForm implements HTTPCompanyAccess
{
    constructor(data : CompanyAccess) {}
}

/* Company Commercial Settings Start*/

export interface Did {
    id : number,
    iduser : number,
    name   : string,
    account : string,
    key : string,
    status : string,
    isdefault:number,
    id_didapi:number,
    spaceurl:string,
    type:number,
    isdidapi:number
}

export interface HTTPDid
{
    iduser : number,
    name   : string,
    account : string,
    key : string,
    spaceurl:string,
    type:number
}

export class DidForm implements HTTPDid {
    public iduser : number;
    public name : string;
    public account : string;
    public key : string;
    public spaceurl:string;
    public type:number;


    constructor(data : Did)
    {
        if(data==null)
        {
            this.iduser      = parseInt(sessionStorage.getItem('userid'));
            this.name="";
            this.account="";
            this.key="";
            this.spaceurl="";
            this.type=1;

        }
        else
        {   this.iduser      = parseInt(sessionStorage.getItem('userid'));
            this.name=data.name;
            this.account=data.account;
            this.key=data.key;
            this.spaceurl=data.spaceurl;
            this.type=data.type;

        }
    }

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            name: [this.name,Validators.required],
            account: [this.account],
            key: [this.key],
            spaceurl: [this.spaceurl],
            type: [this.type]

        });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {   this.iduser      = parseInt(sessionStorage.getItem('userid'));
            this.name=fg.get("name").value;
            this.account=fg.get("account").value;
            this.key=fg.get("key").value;
            this.spaceurl=fg.get("spaceurl").value;
            return true;
        }
        else
        {
            return false;
        }
    }
}

/* Company Commercial Settings Stop*/


/* company bussiness  hour */

export interface bussiness {
    end: any;
    start: any;
    id : number,
    iduser : number,
    type:number,
    // start:string,
    // end:string,
    day:Array<number>,
    sday:Array<number>,
    vday:Array<number>,
    eday:Array<number>,
    todailtime: string,
    fromdialtime: string,
    tosmstime: string,
    fromsmstime: string,
    toemailtime: string,
    tovoicetime:string,
    fromvoicetime:string,
    fromemailtime: string,
}

export interface HTTPbussiness
{

    iduser : number,
    type:number,
    day:Array<number>,
    sday:Array<number>,
    vday:Array<number>,
    eday:Array<number>,
    // start:string,
    // end:string,
    todailtime: string,
    fromdialtime: string,
    tosmstime: string,
    fromsmstime: string,
    toemailtime: string,
    tovoicetime:string,
    fromvoicetime:string,
    fromemailtime: string,
}

export class bussinesForm implements HTTPbussiness {
    public iduser : number;
    public type : number;
    // public start : string;
    // public end : string;
    public  day:Array<number>;
   public sday:Array<number>;
    public vday:Array<number>;
   public eday:Array<number>;
    public todailtime: string;
    public fromdialtime: string
    public tosmstime: string
    public fromsmstime: string
   public toemailtime: string
   public tovoicetime:string
   public fromvoicetime:string
    public fromemailtime: string




    constructor(data : bussiness)
    {
        if(data==null)
        {
           this.iduser      = parseInt(sessionStorage.getItem('userid'));
           this.type=null;
           // this.start="";
            this.day=[1,2,3,4,5]
           this.sday=[1,2,3,4,5]
           this.vday=[1,2,3,4,5]
           this.eday=[1,2,3,4,5]
            // this.end="";
           this.todailtime="06:00";
           this. fromdialtime="20:00"
           this.tosmstime="06:00"
           this.fromsmstime="20:00"
           this.toemailtime="06:00"
           this. fromemailtime="20:00"
           this.tovoicetime="06:00"
           this.fromvoicetime="20:00"



        }
        else
        {   this.iduser      = parseInt(sessionStorage.getItem('userid'));
            this.type=data.type;
            this.day=data.day;
            this.sday=data.sday;
            this.vday=data.vday;
            this.eday=data.eday;
            this.todailtime=data.todailtime;
            this.fromdialtime=data.fromdialtime
            this.tosmstime=data.tosmstime
            this.fromsmstime=data.fromsmstime

            this.tovoicetime=data.tovoicetime
            this.fromvoicetime=data.fromvoicetime
            this.fromemailtime=data.fromemailtime
            this.toemailtime=data.toemailtime
            if(data.day!=null){
                this.day       = JSON.parse("["+data.day+"]");
            }else{
                this.day       = [];
            }

            if(data.sday!=null){
                this.sday       = JSON.parse("["+data.sday+"]");
            }else{
                this.sday       = [];
            }
            if(data.vday!=null){
                this.vday       = JSON.parse("["+data.vday+"]");
            }else{
                this.vday       = [];
            }
            if(data.eday!=null){
                this.eday       = JSON.parse("["+data.eday+"]");
            }else{
                this.eday       = [];
            }


        }
    }

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            type: [this.type],
            day:[this.day],
            sday:[this.sday],
            vday:[this.vday],
            eday:[this.eday],
            todailtime:[this.todailtime],
            fromdialtime:[this.fromdialtime],
            tosmstime:[this.tosmstime],
            fromsmstime:[this.fromsmstime],
            fromemailtime:[this.fromemailtime],
            toemailtime:[this.toemailtime],
            tovoicetime:[this.tovoicetime],
            fromvoicetime:[this.fromvoicetime],

            // start: [this.start],
            // end: [this.end],

        });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {   this.iduser      = parseInt(sessionStorage.getItem('userid'));
            this.type=fg.get("type").value;

            this.day=fg.get("day").value;
            this.sday=fg.get("sday").value;
            this.vday=fg.get("vday").value;
            this.eday=fg.get("eday").value;
            this.todailtime=fg.get("todailtime").value;
            this.fromdialtime=fg.get("fromdialtime").value;
            this.tosmstime=fg.get("tosmstime").value;
            this.fromsmstime=fg.get("fromsmstime").value;
            this.toemailtime=fg.get("toemailtime").value;
            this.tovoicetime=fg.get("tovoicetime").value;
            this.fromvoicetime=fg.get("fromvoicetime").value;
            this.fromemailtime=fg.get("fromemailtime").value;
            // this.start=fg.get("start").value;
            // this.end=fg.get("end").value;


            return true;
        }
        else
        {
            return false;
        }
    }
}
